import { useTheme } from "@mui/material/styles";
import PhotoAlbum from "react-photo-album";
import { Box, Typography } from "@mui/material";

export default function Album(props) {
  const { album } = props;
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      pt={theme.spacing(12)}
      pl={{ xs: theme.spacing(5), md: theme.spacing(35) }}
      pr={{ xs: theme.spacing(5), md: theme.spacing(35) }}
      pb={theme.spacing(12)}
    >
      <Typography variant="h4" sx={{ pb: theme.spacing(2) }}>
        {album.albumTitle}
      </Typography>
      <Typography variant="h6" sx={{ pb: theme.spacing(5) }}>
        {album.albumDesc}
      </Typography>
      <PhotoAlbum
        layout="masonry"
        spacing={30}
        columns={1}
        photos={album.photos}
      />
    </Box>
  );
}
